import {addDays, parse} from "date-fns";


export default class AppSupport {


    static pxToVwDesktop(psFontSize: number) {
        return `${(psFontSize / 1920 * 100)}vw`;
    }

    static pxToVwMob(psFontSize: number) {
        return `${(psFontSize / 1440 * 100)}vw`;
    }


    static regulamentUrl(){
        return '/static/Regulament Cremosso autentificat.pdf'
    }

    /**
     * fdate = date start campanieni format aaaa-ll-zz, prima zi de campanie
     * @param fdate
     */
    static campHasStarted(fdate: string): boolean {
        let dataStart = parse(fdate, 'yyyy-MM-dd', new Date())
        return new Date() >= dataStart;
    }

    /**
     *
     * @param last_participa_date = ultima zi de inscriere, NU ziua de dupa ultima zi de inscriere
     */
    static campHasEnded(last_participa_date: string): boolean {
        let dataEnd = parse(last_participa_date, 'yyyy-MM-dd', new Date())
        let firstDateAfterEndAtHour00 = addDays(dataEnd, 1);
        //>= pt ca new Date e cu ora:minut:secunda 00:00:00 asa ca luam urmatoare zi pt comparatie
        return new Date() >= firstDateAfterEndAtHour00;
    }

}